module.exports = __webpack_public_path__ + "img/ecp_logo_black.c8363005.svg";